import React, { useState, useEffect, useContext } from 'react'
import { Link } from 'react-router-dom'
import { LangContext } from '../../context/lang-context'
import useFetch from '../../hooks/fetchMSSQL-hook'
import SearchFilter from "../../components/Filter/SearchFilter"
import NoResults from '../../components/NoResults/NoResults'
import moment from "moment";
import { NavigationContext } from '../../context/navigation-context'
import ReportButton from '../../components/Buttons/ReportButton'
import { NotificationManager } from 'react-notifications'

const INS = () => {
  const { TRL_Pack } = useContext(LangContext)
  const { fetchMssqlApi } = useFetch()
  const { setHeaderData } = useContext(NavigationContext)
  const [windowHeight, setWindowHeight] = useState(window.innerHeight)
  const [INS, setINS] = useState([])

  const defaultFilter = {
    page: 1,
    rowsPerPage: 50,
    sortBy: "none",
    dateTimeRangeFrom: moment().startOf("day").format("YYYY-MM-DDTHH:mm:ss"),
    dateTimeRangeTo: moment().endOf("day").format("YYYY-MM-DDTHH:mm:ss"),
    warehouseId: null,
    warehouseName: "",
    userId: null,
    userName: ""
  }

  const [filter, setFilter] = useState(defaultFilter);
  const [settingsFilter, setSettingsFilter] = useState({
    saveFilters: true,
    autoLoading: true,
    additionalFilter: true,
    flatView: false,
    rowsPerPage: 50,
  });

  const rowsPerPage = settingsFilter.rowsPerPage || filter.rowsPerPage || 50;

  const sortDefaults = {
    IN: "DESC",
    Created: "DESC",
    WarehouseFullName: "ASC",
    Comment: "ASC",
    IssuedOn: "DESC",
  };

  const getSortState = () => {
    const [field, dir] = String(filter.sortBy || "").split("|");
    return { field, dir: (dir || "").toUpperCase() };
  };

  const sortState = getSortState();

  const arrow = (field) => {
    if (sortState.field !== field) return "";
    return sortState.dir === "ASC" ? " ▲" : " ▼";
  };

  const handleHeaderSort = (field) => {
    const [curField, curDirRaw] = String(filter.sortBy || "").split("|");
    const curDir = (curDirRaw || "").toUpperCase();

    let nextDir;
    if (curField === field) {
      nextDir = curDir === "ASC" ? "DESC" : "ASC";
    } else {
      nextDir = sortDefaults[field] || "ASC";
    }

    const next = { ...filter, sortBy: `${field}|${nextDir}`, page: 1 };
    setFilter(next);

    getINS(
      next.dateTimeRangeFrom,
      next.dateTimeRangeTo,
      next.warehouseId,
      next.userId,
      next.sortBy
    );
  };

  const search = (f = filter) => {
    if (!moment(f.dateTimeRangeFrom).isValid() ||
        !moment(f.dateTimeRangeTo).isValid()) 
    {
      NotificationManager.error("Wybierz poprawną datę");
      return;
    }

    getINS(
      f.dateTimeRangeFrom,
      f.dateTimeRangeTo,
      f.warehouseId,
      f.userId,
      f.sortBy
    );
  };

  const getINS = (
    fromCreateDateTime = moment().add(-30, "d").format("YYYY-MM-DDTHH:mm:ss"),
    toCreateDateTime = moment().format("YYYY-MM-DDT23:59:59"),
    warehouseId = null,
    createUserId = null,
    sortBy = null
  ) => {
    fetchMssqlApi(
      "in-ins",
      {
        method: "POST",
        hideNotification: true,
        data: {
          clientId: sessionStorage.getItem("clientId"),
          fromCreateDateTime,
          toCreateDateTime,
          warehouseId,
          createUserId,
          sortBy,
        },
      },
      (response) => {
        setINS(response);
      }
    );
  };

  useEffect(() => {
    setHeaderData({ text: TRL_Pack.in.ins });
  }, []);

  return (
    <div>
      <SearchFilter
        filterName="ins"
        defaultFilter={defaultFilter}
        onFilterChange={(f) => setFilter(f)}
        onSettingsChange={(s) => setSettingsFilter(s)}
        search={search}
        totalCount={INS.slice(
          (filter.page - 1) * rowsPerPage,
          filter.page * rowsPerPage
        ).length}
        dataList={INS}
        forNow
      />

      <div className="card">
        <div className="card-header">
          <div className="d-flex justify-content-between">
            <div></div>
            <Link
              to={`/in/0`}
              className="btn text-nowrap btn-outline-secondary mt-1 mb-1"
            >
              <i className="fas fa-plus" />
            </Link>
          </div>
        </div>

        <div
          className="overflow-auto custom-scroll"
          style={{ maxHeight: "calc(100vh - 150px)" }}
        >
          {INS.length ? (
            <table className="table table-striped">
              <thead>
                <tr className="text-center headers-color">
                  <th
                    style={{ cursor: "pointer", userSelect: "none" }}
                    onClick={() => handleHeaderSort("IN")}
                  >
                    Nr{arrow("IN")}
                  </th>
                  <th
                    style={{ cursor: "pointer", userSelect: "none" }}
                    onClick={() => handleHeaderSort("Created")}
                  >
                    Czas zapisu, Źródło{arrow("Created")}
                  </th>
                  <th
                    style={{ cursor: "pointer", userSelect: "none" }}
                    onClick={() => handleHeaderSort("WarehouseFullName")}
                  >
                    Magazyn{arrow("WarehouseFullName")}
                  </th>
                  <th
                    style={{ cursor: "pointer", userSelect: "none" }}
                    onClick={() => handleHeaderSort("Comment")}
                  >
                    Komentarz{arrow("Comment")}
                  </th>
                  <th
                    style={{ cursor: "pointer", userSelect: "none" }}
                    onClick={() => handleHeaderSort("IssuedOn")}
                  >
                    Data inwentaryzacji{arrow("IssuedOn")}
                  </th>
                  <th></th>
                </tr>
              </thead>
              <tbody>
                {INS.slice(
                  (filter.page - 1) * rowsPerPage,
                  filter.page * rowsPerPage
                ).map((entry, idx) => (
                  <tr className="text-center" key={idx}>
                    <td>
                      <Link
                        to={`/in/${entry.WarehouseInventoryId}`}
                        className="btn text-nowrap btn-sm btn-outline-secondary"
                      >
                        IN {entry.WarehouseInventoryId}/{entry.Created.slice(5, 7)}/{entry.Created.slice(8, 10)}
                      </Link>
                    </td>
                    <td>{entry.Created}</td>
                    <td>{entry.WarehouseFullName}</td>
                    <td>{entry.Comment}</td>
                    <td>{entry.IssuedOn}</td>
                    <td>
                      <div className='d-flex flex-row justify-content-end'>
                        <ReportButton
                          reportId={26}
                          body={{
                            warehouseInventoryId: entry.WarehouseInventoryId,
                            warehouseCreate: entry.Created,
                            warehouseFullName: entry.WarehouseFullName,
                            warehouseComment: entry.Comment,
                            warehouseIssuedOn: entry.IssuedOn
                          }}
                          btnColor='primary'
                          isPrimary
                        />
                        <ReportButton
                          reportId={27}
                          body={{
                            warehouseInventoryId: entry.WarehouseInventoryId,
                            warehouseCreate: entry.Created,
                            warehouseFullName: entry.WarehouseFullName,
                            warehouseComment: entry.Comment,
                            warehouseIssuedOn: entry.IssuedOn
                          }}
                          btnColor='danger'
                          isPrimary
                        />
                        <ReportButton
                          reportId={28}
                          body={{
                            warehouseInventoryId: entry.WarehouseInventoryId,
                            warehouseCreate: entry.Created,
                            warehouseFullName: entry.WarehouseFullName,
                            warehouseComment: entry.Comment,
                            warehouseIssuedOn: entry.IssuedOn
                          }}
                          btnColor='success'
                          isPrimary
                        />
                        <ReportButton
                          reportId={31}
                          body={{
                            warehouseInventoryId: entry.WarehouseInventoryId,
                            warehouseCreate: entry.Created,
                            warehouseFullName: entry.WarehouseFullName,
                            warehouseComment: entry.Comment,
                            warehouseIssuedOn: entry.IssuedOn
                          }}
                          btnColor='dark'
                          isPrimary
                        />
                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          ) : (
            <NoResults />
          )}
        </div>
      </div>
    </div>
  );
};

export default INS;